/** @jsxImportSource @compiled/react */
import { cssMap } from '@atlaskit/css';
import { AutoDismissFlag, FlagGroup } from '@atlaskit/flag';
import Tick from '@atlaskit/icon/core/status-success';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';
import { FormattedMessage } from 'react-intl';

import { portalZIndexFix } from '../utils/portalZIndexFix';

const POST_OFFICE_AD_CONTROLS_FLAG_WRAPPER = 'post-office-ad-controls-flag-wrapper';

/**-Title--**/

const titleContainerStyles = cssMap({
	font: {
		font: token('font.heading.xsmall'),
	},
});

const Title = () => (
	<Box xcss={titleContainerStyles.font}>
		<FormattedMessage
			id="post-office.ad-controls-sequoia.dismiss-flag.not-interested.title"
			defaultMessage="Got it, thanks for letting us know"
			description="The title for a flag which is displayed when the Not Interested button is pressed. https://hello.atlassian.net/l/cp/ssoqm2Fq"
		/>
	</Box>
);

/**--Description--**/

const Description = () => (
	<FormattedMessage
		id="post-office.ad-controls-sequoia.dismiss-flag.not-interested.subtitle"
		defaultMessage="You won’t see this here as often."
		description="The subtitle for a flag which is displayed when the Not Interested button is pressed. https://hello.atlassian.net/l/cp/ssoqm2Fq"
	/>
);

/**--Confirm Icon--*/

const ConfirmIcon = () => (
	<Tick spacing="spacious" label="Success" color={token('color.icon.success', '#36B37E')} />
);

/**-Confirm Dismiss Flag--*/

export type AdControlsFlagProps = {
	messageInstanceId: string;
	onCloseFlag: () => void;
};

export const AdControlsFlag = ({
	messageInstanceId,
	onCloseFlag,
}: AdControlsFlagProps): JSX.Element => {
	portalZIndexFix(POST_OFFICE_AD_CONTROLS_FLAG_WRAPPER);
	return (
		<FlagGroup>
			<div id={POST_OFFICE_AD_CONTROLS_FLAG_WRAPPER}>
				<AutoDismissFlag
					icon={<ConfirmIcon />}
					title={<Title />}
					description={<Description />}
					id={messageInstanceId}
					key={messageInstanceId}
					onDismissed={() => onCloseFlag()}
				/>
			</div>
		</FlagGroup>
	);
};
